import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material";

import { TranslationSubstitutions, TranslateService } from "../translate";
import { isHttpResponse, isHttpErrorResponse } from "../../util";
import { HttpErrorResponse } from "@angular/common/http";

const DURATION = 8000;

@Injectable()
export class SnackbarService {
	constructor(
		private snackBar: MatSnackBar,
		private snackConfig: MatSnackBarConfig,
		private translateService: TranslateService
	) {
		this.snackConfig.panelClass = ["sdp-snackbar-extra"];
	}

	public open(message: string) {
		this.snackBar.open(
			message,
			"X",
			{
				duration: DURATION,
				verticalPosition: "top"
			}
		);
	}

	public showErrorBar(e: any, args?: TranslationSubstitutions) {
		if (isHttpErrorResponse(e)) {
			this.open(this.translateService.translate(e.error.message, args));
		} else {
			this.open(this.translateService.translate("sdp.error.unknown"));
		}
	}

}
